/**
 * Machine a etats de commande — implementation unique (spec § 4).
 * Consommee par l'API et affichee a l'identique par la boutique et le back-office.
 */
export const ORDER_STATUSES = [
    'PENDING',
    'CONFIRMED',
    'PREPARING',
    'SHIPPED',
    'OUT_FOR_DELIVERY',
    'DELIVERED',
    'DELIVERY_INCIDENT',
    'CANCELLED',
];
export const STATUS_META = {
    PENDING: { label: 'En attente', tone: 'grey', channels: [], step: null, terminal: false },
    CONFIRMED: {
        label: 'Confirmée',
        tone: 'green',
        channels: ['EMAIL', 'INAPP'],
        step: 1,
        terminal: false,
    },
    PREPARING: {
        label: 'En préparation',
        tone: 'amber',
        channels: ['EMAIL', 'INAPP'],
        step: 2,
        terminal: false,
    },
    SHIPPED: {
        label: 'Expédiée',
        tone: 'blue',
        channels: ['EMAIL', 'INAPP', 'SMS'],
        step: 3,
        terminal: false,
    },
    OUT_FOR_DELIVERY: {
        label: 'En livraison',
        tone: 'blue',
        channels: ['EMAIL', 'INAPP', 'SMS'],
        step: 4,
        terminal: false,
    },
    DELIVERED: {
        label: 'Livrée',
        tone: 'green',
        channels: ['EMAIL', 'INAPP'],
        step: 5,
        terminal: true,
    },
    DELIVERY_INCIDENT: {
        label: 'Incident de livraison',
        tone: 'amber',
        channels: ['EMAIL', 'INAPP'],
        step: null,
        terminal: false,
    },
    CANCELLED: {
        label: 'Annulée',
        tone: 'red',
        channels: ['EMAIL', 'INAPP'],
        step: null,
        terminal: true,
    },
};
/** Parcours lineaire affiche dans le detail commande (spec § 3.3). */
export const ORDER_JOURNEY = [
    'CONFIRMED',
    'PREPARING',
    'SHIPPED',
    'OUT_FOR_DELIVERY',
    'DELIVERED',
];
const TRANSITIONS = {
    PENDING: ['CONFIRMED', 'CANCELLED'],
    CONFIRMED: ['PREPARING', 'CANCELLED'],
    PREPARING: ['SHIPPED', 'CANCELLED'],
    SHIPPED: ['OUT_FOR_DELIVERY', 'DELIVERY_INCIDENT', 'CANCELLED'],
    OUT_FOR_DELIVERY: ['DELIVERED', 'DELIVERY_INCIDENT'],
    DELIVERY_INCIDENT: ['OUT_FOR_DELIVERY', 'CANCELLED'],
    DELIVERED: [],
    CANCELLED: [],
};
export const ORDER_EDITABILITY = {
    PENDING: { lines: true, delivery: true, discount: true, contact: true },
    CONFIRMED: { lines: true, delivery: true, discount: true, contact: true },
    PREPARING: { lines: false, delivery: true, discount: false, contact: true },
    SHIPPED: { lines: false, delivery: false, discount: false, contact: false },
    OUT_FOR_DELIVERY: { lines: false, delivery: false, discount: false, contact: false },
    DELIVERED: { lines: false, delivery: false, discount: false, contact: false },
    DELIVERY_INCIDENT: { lines: false, delivery: true, discount: false, contact: true },
    CANCELLED: { lines: false, delivery: false, discount: false, contact: false },
};
export function allowedTransitions(from) {
    return TRANSITIONS[from];
}
export function canTransition(from, to) {
    return TRANSITIONS[from].includes(to);
}
/** Etape suivante du parcours lineaire, pour le bouton « etape suivante ». */
export function nextStep(from) {
    if (from === 'PENDING')
        return 'CONFIRMED';
    const i = ORDER_JOURNEY.indexOf(from);
    if (i === -1 || i === ORDER_JOURNEY.length - 1)
        return null;
    return ORDER_JOURNEY[i + 1] ?? null;
}
export class InvalidTransitionError extends Error {
    from;
    to;
    constructor(from, to) {
        super(`Transition interdite : ${from} -> ${to}`);
        this.from = from;
        this.to = to;
        this.name = 'InvalidTransitionError';
    }
}
/**
 * Point de passage unique de tout changement de statut. Le domaine refuse une
 * transition invalide — l'interface n'est jamais la seule barriere.
 */
export function assertTransition(from, to) {
    if (!canTransition(from, to))
        throw new InvalidTransitionError(from, to);
}
export function channelsFor(status) {
    return STATUS_META[status].channels;
}
export function isEditable(status, field) {
    return ORDER_EDITABILITY[status][field];
}
//# sourceMappingURL=order-status.js.map